import type { ComponentProps } from "react";

import { cn } from "./cn";

// A text control is at least 44 px high (32 px in the compact density). Its border is the `input` token, which has at least 3:1
// contrast against the page. An invalid control gets a thicker danger border, so the state is not colour alone: the field also shows
// an error message (see `fields.tsx`).

export const controlClasses =
  "w-full min-w-0 rounded-md border border-input bg-card px-3 text-base leading-6 text-foreground placeholder:text-muted-foreground read-only:bg-muted disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground aria-invalid:border-2 aria-invalid:border-destructive md:text-sm";

export function Input({ className, type = "text", ...props }: ComponentProps<"input">) {
  return (
    <input
      type={type}
      className={cn(
        controlClasses,
        "h-11 compact:h-8 file:mr-3 file:border-0 file:bg-transparent file:text-sm file:font-medium",
        className,
      )}
      {...props}
    />
  );
}

export function Textarea({ className, ...props }: ComponentProps<"textarea">) {
  return (
    <textarea className={cn(controlClasses, "min-h-24 resize-y py-2", className)} {...props} />
  );
}
